import { render } from "./crossChain.vue?vue&type=template&id=886be050&scoped=true&lang=pug"
import script from "./crossChain.vue?vue&type=script&setup=true&lang=js"
export * from "./crossChain.vue?vue&type=script&setup=true&lang=js"

import "./crossChain.vue?vue&type=style&index=0&id=886be050&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/cross-bridge v0.1.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-886be050"]])

export default __exports__